var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['back-to-top', { 'back-to-top--show': _vm.showButton }],on:{"click":_vm.scrollToTop}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }